import type { SVGProps } from 'react';
export const AccountStatusArchived = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 10 8" {...props}>
    <path d="M9.29.43H.7a.7.7 0 0 0-.71.71v1.07a.7.7 0 0 0 .71.72v3.93a.7.7 0 0 0 .72.71h7.14a.7.7 0 0 0 .72-.71V2.93A.7.7 0 0 0 10 2.2V1.14a.7.7 0 0 0-.71-.71m-.72 6.43H1.43V2.93h7.14zM9.3 2.2H.7V1.14H9.3zM3.57 4.36A.36.36 0 0 1 3.93 4h2.14a.36.36 0 0 1 0 .71H3.93a.36.36 0 0 1-.36-.35" />
  </svg>
);
